import ACTION_NAMES from "actions/ACTION_NAMES";
import { generateReadActionCreator } from "actions/crudActionCreators";
import routes from "actions/routes";

export default {
    readAll: generateReadActionCreator(routes.API_INVOICE_REPORT, ACTION_NAMES.INVOICE_REPORT),
    readPowerSelectors: generateReadActionCreator(routes.API_INVOICE_REPORT_POWER_SELECTORS, ACTION_NAMES.INVOICE_REPORT_POWER_SELECTORS)
}
